/* eslint-disable react/no-unescaped-entities */
import React from 'react'
import Image2 from '../../../assets/images/Image (1).png'
import Spinner from '../../../components/Spinner'
import PrimaryButton from '../../../components/buttons/PrimaryButton'
import CheckInformationWrapper from '../CheckInformationWrapper'
import DefaultPage from '../DefaultPage'

import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { useLocation } from 'react-router'
import {
  InfoIcon,
} from '../../../assets/AppIcons'
import { AppStyles } from '../../../assets/styles/AppStyles'
import SpinnerLarge from '../../../components/SpinnerLarge'
import OnEnter from '../../../components/navigation/onEnter'
import {
  getAgreementDocs,
} from '../../../redux/Actions/getMethods'
import { ActionTypes } from '../../../redux/Constants/actionTypes'
import { useTheme } from '../../../utils/ThemeColorContext'
import TagManager from 'react-gtm-module'

const SignAgreement = () => {
  const { loading } = useSelector((state) => state.authReducer)
  const { getApplication, loadingWholeScreen } =
    useSelector((state) => state.dataReducer)

  const dispatch = useDispatch()
  const { color, isSmallScreen } = useTheme()
  const navigate = useNavigate()
  const location = useLocation()

  const id = getApplication[0]?.id

  // useEffect(() => {
  //   if (token?.email) {
  //     localStorage.setItem(`journeyStep-${token?.email}`, '/signagreement')
  //   }
  // }, [token?.email])

  useEffect(() => {
    if (id) {
      dispatch(getAgreementDocs(id, 'credit', ActionTypes.GET_AGREMENT_DOCS))
    }
  }, [id])

  async function convertHtmlToPdf() {
    navigate('/loan-agreement')
  }

  // ==================== Checking user status  =======================//
  useEffect(() => {
    const temp = async () => {
      dispatch({ type: ActionTypes.LOADING_SUCCESS_WHOLE_SCREEN })
      // const myID = await dispatch(getApplications())
      if (getApplication[0]?.status === 'APPROVED') {
        dispatch({ type: ActionTypes.LOADING_FAIL_WHOLE_SCREEN })
        //navigate('/signagreement')
        // do nothing
      } else {
        dispatch({ type: ActionTypes.LOADING_FAIL_WHOLE_SCREEN })
        navigate('/address-detail')
      }
    }
    temp()
  }, [])

  return (
    <DefaultPage>
      {loadingWholeScreen ? (
        <SpinnerLarge />
      ) : (
        <div className="md:flex md:w-[792px] m-[auto] py-10 md:py-0">
        <CheckInformationWrapper img={Image2}>
          <div className="w-full space-y-8  md:space-y-10 ">
            <div className=" space-y-4 md:space-y-6 ">
              <div className="flexflex-col items-center ">
                <h1
                  style={
                    isSmallScreen
                      ? { ...AppStyles.Title1, color: color.Plum }
                      : { ...AppStyles.LargeTitle2, color: color.Plum }
                  }
                  className=" text-center"
                >
                  Let's get your<br/>agreement signed
                </h1>
              </div>
              <div
                style={{
                  backgroundColor: color,
                  borderColor: color.MidGrey,
                  margin: '16px 0',
                  height: isSmallScreen && '100%',
                }}
                className="border w-full rounded-[16px] flex p-4 space-x-4 "
              >
                <div className="">
                  <InfoIcon fill={color.BlurpleTeal} />
                </div>
                <div className="flex flex-col space-y-2">
                  <b
                    style={{
                      ...AppStyles.BodyBold,
                      color: color.BlurpleTeal,
                    }}
                  >
                    eSignature
                  </b>
                  <p
                    style={{
                      ...AppStyles.Body12Demi,
                      color: color.Grey,
                      width: isSmallScreen && '100%',
                      lineHeight: isSmallScreen && '20px',
                      height: isSmallScreen && '100%',
                    }}
                    className="leading-[20px]"
                  >
                    By proceeding you are agreeing to receive documentation
                    digitally in PDF format through the Updraft app within your
                    account settings and to the email address that you gave us
                    when you applied for the agreement.
                  </p>
                  <p
                    style={{
                      ...AppStyles.Body12Demi,
                      color: color.Grey,
                      width: isSmallScreen && '100%',
                      lineHeight: isSmallScreen && '20px',
                      height: isSmallScreen && '100%',
                    }}
                    className="leading-[20px]"
                  >
                    Such documentation includes notices, statements or other
                    documents under the Consumer Credit Act 1974 and a copy of
                    the signed agreement upon signing.
                  </p>
                </div>
              </div>
            </div>
            <OnEnter
              actionFunction={() => {
                if (loading) {
                  return
                }
                const tagManagerArgs = {
                  dataLayer: {
                    event: 'onenter-view-loan-agreement',
                    page: location?.pathname,
                  }
                }
                TagManager.dataLayer(tagManagerArgs)
                convertHtmlToPdf()
              }}
            />
            <div className=" space-y-2">
              <PrimaryButton
                id={'sign-agreement-btn'}
                disabled={loading}
                text={loading ? <Spinner /> : 'View Your Loan Agreement'}
                onClick={() => {
                  if (loading) {
                    return
                  }
                  convertHtmlToPdf()
                }}
              />
            </div>
          </div>
        </CheckInformationWrapper>
        </div>
      )}
    </DefaultPage>
  )
}

export default SignAgreement
